import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Gera o relatório em PDF.
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {String} microArea
 */
export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Atendimentos pessoa'
  let titlePdfSave = utils.methods.titlePdf('Atendimentos pessoa')

  let description_pdf = ''
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'ATENDIMENTO']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    let dados = JSON.parse(cadastros[i].dados)
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) +
      `\n(${cadastros[i].idade} ${cadastros[i].idade > 1 ? 'anos' : 'ano'})`
    obj.no_mae = cadastros[i].no_mae
    obj.atendimento =
      dados != null ? utils.methods.formatDate(dados.dt_atendimento) : ''
    obj.num_mais_acesso = cadastros[i].num_mais_acesso
    data_pdf.push(obj)
  }

  let doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let num_mais_acesso = data.row.raw[4]
          if (num_mais_acesso >= 1) {
            doc.setTextColor(2, 99, 57) // verde
          } else {
            doc.setTextColor(255, 165, 0) // laranja
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
